import {client} from '../helpers/api';

export async function postChangePassword({oldPassword, newPassword}) {
  const body = {old_password: oldPassword, new_password: newPassword};

  const response = await client.post('/auth/change-password', body);

  if (response.data?.status) {
    return response.data?.message || 'Success';
  } else if (response.data?.status === false) {
    return response.data?.message || '';
  }
  throw response;
}
